import React from 'react';
import PropTypes from 'prop-types';
import { validSteps } from 'utils/types';
import { STEPS } from 'utils/scheduler';

export default class StepSwitch extends React.Component {

  get content() {
    switch ( this.props.step ) {
      case STEPS.PICK_A_REASON:
        if ( this.props.isService ) return this.props.renderServiceReasonsContainer();
        if ( this.props.isConnection ) return this.props.renderConnectionReasonsContainer();
        return null; // Should not happen
      case STEPS.PICK_A_TIME:
        return this.props.renderSlotsContainer();
      case STEPS.REVIEW_APPOINTMENT:
        return this.props.renderReview();
      case STEPS.CHANGE_DURATION:
        return this.props.renderDuration();
      case STEPS.ADD_COURSE:
        return this.props.renderCourse();
      case STEPS.CONFIRMATION_SCREEN:
        return this.props.renderConfirmation();
      default:
        return null;
    }
  }

  render() {
    return this.content;
  }
}

StepSwitch.propTypes = {
  isConnection: PropTypes.bool,
  isService: PropTypes.bool,
  step: PropTypes.oneOf(validSteps).isRequired,
  renderServiceReasonsContainer: PropTypes.func.isRequired,
  renderConnectionReasonsContainer: PropTypes.func.isRequired,
  renderDuration: PropTypes.func.isRequired,
  renderSlotsContainer: PropTypes.func.isRequired,
  renderReview: PropTypes.func.isRequired,
  renderCourse: PropTypes.func.isRequired,
  renderConfirmation: PropTypes.func.isRequired
};
